import React, { useEffect, useState } from 'react';

// ===================== 🔄 แจ้ง "มีเวอร์ชันใหม่" (ผู้ใช้ขอ 22/10/2569) =====================
// เบราว์เซอร์จำหน้าเก่าไว้ได้หลังอัปโหลดเวอร์ชันใหม่ → ตรวจทุก 5 นาที และทุกครั้งที่กลับมาเปิดแท็บ / แอป
// เทียบไฟล์โปรแกรม (main.xxxx.js) ของหน้านี้กับบนเว็บ ต่างกัน = ขึ้นแถบให้กดโหลดใหม่ (ไม่โหลดเอง กันงานที่กรอกค้างหาย)
const mine = () => { const s = document.querySelector('script[src*="/static/js/main."]'); const m = s && /main\.([0-9a-f]+)\.js/.exec(s.getAttribute('src')); return m ? m[1] : ''; };

export default function UpdateNotice() {
  const [fresh, setFresh] = useState(false), [later, setLater] = useState(false);
  useEffect(() => {
    const cur = mine();
    if (!cur) return undefined;   // เครื่องทดสอบ (localhost) ไม่มีไฟล์ main.xxxx.js → ไม่ต้องตรวจ
    let off = false;
    const check = async () => {
      if (off || document.visibilityState === 'hidden') return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: 'no-store' })).text();
        const m = /static\/js\/main\.([0-9a-f]+)\.js/.exec(html);
        if (!off && m && m[1] !== cur) { setFresh(true); setLater(false); }
      } catch { /* ออฟไลน์ — ลองใหม่รอบหน้า */ }
    };
    const t = setInterval(check, 5 * 60 * 1000);
    const onShow = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onShow); window.addEventListener('focus', onShow);
    check();
    return () => { off = true; clearInterval(t); document.removeEventListener('visibilitychange', onShow); window.removeEventListener('focus', onShow); };
  }, []);
  if (!fresh || later) return null;
  return <div role="alert" style={{ position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 200, margin: '0 auto', maxWidth: 560, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center',
    background: '#0b4fb3', color: '#fff', borderRadius: 12, padding: '10px 14px', boxShadow: '0 8px 24px #0f172a40', fontFamily: 'inherit' }}>
    <span style={{ flex: '1 1 220px', fontSize: 14 }}><b>🔄 มีเวอร์ชันใหม่ของเว็บ</b><br /><span style={{ fontSize: 12.5, opacity: 0.9 }}>บันทึกงานที่กรอกค้างไว้ก่อน แล้วกดโหลดใหม่</span></span>
    <button type="button" onClick={() => window.location.reload()} style={{ padding: '8px 14px', border: 0, borderRadius: 8, background: '#fff', color: '#0b4fb3', fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }}>โหลดใหม่</button>
    <button type="button" onClick={() => setLater(true)} style={{ padding: '8px 10px', border: '1px solid #ffffff88', borderRadius: 8, background: 'transparent', color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>ไว้ทีหลัง</button>
  </div>;
}
